import { THEME } from 'src/config/config'
import { apolloSdk } from 'src/graphql/apolloSdk'
import { IEnum_Solution_Type } from 'src/graphql/generated/hooks'
import { CompareSolution } from 'src/types'

import { SolutionDataFragment } from './SolutionDataFragment'

export const getSolutionsBySlugs = async (
  vendors: CompareSolution[],
  solutionType: IEnum_Solution_Type,
): Promise<CompareSolution[]> => {
  const compares: CompareSolution[] = await Promise.all(
    vendors.map(async (item) => {
      const slug = item.slug.split('#').join(',')
      let solutions
      if (solutionType === IEnum_Solution_Type.Product) {
        const result = await apolloSdk.productBySlug({ slug, includeIlta: THEME === 'ilta' })
        solutions = result.solutions
      } else if (solutionType === IEnum_Solution_Type.Consultancy) {
        const result = await apolloSdk.consultancyBySlug({ slug, includeIlta: THEME === 'ilta' })
        solutions = result.solutions
      } else if (solutionType === IEnum_Solution_Type.Alsp) {
        const result = await apolloSdk.alspBySlug({ slug, includeIlta: THEME === 'ilta' })
        solutions = result.solutions
      }

      return {
        id: solutions?.data[0]?.id || '',
        logo: solutions?.data[0]?.attributes?.logo?.data?.attributes?.url || '',
        slug,
        solutionType,
      }
    }),
  )

  return compares
}

export const getFullSolutionsBySlugs = async (
  slugs: string[],
  solutionType: IEnum_Solution_Type,
): Promise<SolutionDataFragment[]> => {
  const compares = await Promise.all(
    slugs.map(async (slug) => {
      let solutions
      if (solutionType === IEnum_Solution_Type.Product) {
        const result = await apolloSdk.productBySlug({ slug, includeIlta: THEME === 'ilta' })
        solutions = result.solutions
      } else if (solutionType === IEnum_Solution_Type.Consultancy) {
        const result = await apolloSdk.consultancyBySlug({ slug, includeIlta: THEME === 'ilta' })
        solutions = result.solutions
      } else if (solutionType === IEnum_Solution_Type.Alsp) {
        const result = await apolloSdk.alspBySlug({ slug, includeIlta: THEME === 'ilta' })
        solutions = result.solutions
      }
      const vendor = solutions && solutions.data.length > 0 ? solutions.data[0] : null
      return vendor
    }),
  )

  return compares.filter((product): product is SolutionDataFragment => !!product)
}
